<template>
    <div class="basic_wrap">
        <!-- 确保 iframeSrc 加载完成后再渲染 -->
        <iframe 
            v-if="iframeSrc"
            :src="iframeSrc" 
            class="external-link"
            frameborder="0"
            allowfullscreen
            scrolling="yes">
        </iframe>
    </div>
</template>

<script>
    export default {
        name: "activity",
        data() {
            return {
                lang: this.$i18n.locale || "zh_cn",
                data: {},
                show_ver: false,
                iframeSrc: "", // 用于存储从 JSON 获取的 URL
            };
        },
        created() {
            this.$parent.footer('cart');
            this.fetchIframeSrc(); // 调用方法获取 iframe 的 src
        },
        methods: {
            // 获取 iframe 的 src 地址
            async fetchIframeSrc() {
                try {
                    // 在请求 URL 后添加时间戳，避免缓存
                    const url = `https://liumiaomiao.oss-cn-hongkong.aliyuncs.com/7dd58111ac1d44c5a3728b1d052b9f62.json?timestamp=${Date.now()}`;
                    
                    // 下载 JSON 文件
                    const response = await fetch(url);

                    // 检查响应状态
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    // 将响应转换为 Blob 对象
                    const blob = await response.blob();

                    // 读取 Blob 内容
                    const text = await blob.text(); // 将 Blob 转换为文本
                    const result = JSON.parse(text); // 解析 JSON 数据

                    // 检查 JSON 数据并设置 iframeSrc
                    if (result.code === 0 && result.data && result.data.lts) {
                        this.iframeSrc = result.data.lts; // 设置 iframe 的 src
                        console.log("iframeSrc 设置为：", this.iframeSrc); // 打印 iframeSrc
                    } else {
                        console.error("获取 iframe URL 失败：", result);
                    }
                } catch (error) {
                    console.error("请求 JSON 文件失败：", error);
                }
            },
        },
    };
</script>

<style lang="less" scoped>
.external-link {
    width: 100%; /* 占满父容器宽度 */
    height: calc(100vh - 50px); /* 高度为视口高度减去顶部导航的高度 */
    border: none; /* 去掉边框 */
    overflow: auto; /* 确保 iframe 内部内容可以滚动 */
}
</style>